const SimpleCell = ({ value }: { value: string | number }) => (
  <div className="custom-cell-container">
    <span>{value || '--'}</span>
  </div>
);

export default SimpleCell;
